import { useQuery } from '@tanstack/react-query';
import { useReadProvider } from './useReadProvider';

/**
 * Polls the head block every ~4.5s. Used by the live LED in the navbar
 * and by anything that wants to know "fresh as of which block".
 */
export function useBlockNumber() {
  const provider = useReadProvider();
  return useQuery({
    queryKey: ['blockNumber'],
    queryFn: () => provider.getBlockNumber(),
    refetchInterval: 4500,
    staleTime: 4000,
    refetchIntervalInBackground: false,
  });
}
